"use strict";
// ================================================================
// v2/tokens/spacing.ts
// モード非依存の spacing / radius トークン (px, number)。
// ================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.blur = exports.radius = exports.spacing = void 0;
/** px 値 (number)。Figma spacing 1/2/4/5/8 に対応。 */
exports.spacing = {
    /** 4px — アイコン内パディング */
    xs: 4,
    /** 8px — コンポーネント内ギャップ */
    sm: 8,
    /** 16px — カードパディング・セクション内ギャップ */
    md: 16,
    /** 20px — コンテンツ横パディング */
    lg: 20,
    /** 32px — セクション間ギャップ */
    xl: 32,
};
/** px 値 (number) */
exports.radius = {
    /** 2px — チェックボックス・角形バッジ */
    xxs: 2,
    /** 4px — SKU チップ・入力ボックス */
    xs: 4,
    /** 8px — バッジ・チップ */
    sm: 8,
    /** 12px — カード標準 */
    md: 12,
    /** 16px — アクセントバー端 */
    lg: 16,
    /** 9999px — ピル・アバター */
    full: 9999,
};
/**
 * ガラス表現で用いる blur 量 (px)。CSS の blur() にそのまま渡す値を持つ。
 *
 * Figma のぼかし効果は「半径」指定で、CSS の blur() が取る標準偏差の約 2 倍に
 * あたる。Figma の Dev Mode / MCP も radius = Spacing/space-80 (= 80) の
 * BACKGROUND_BLUR を `blur(40px)` として出力する。
 * 以前は radius の 80 をそのまま CSS に入れていて、実機のぼかしが Figma の
 * 2 倍強くかかっていた。
 */
exports.blur = {
    /** Figma "Card" 効果の BACKGROUND_BLUR radius 80 → CSS blur(40px) */
    card: 40,
    /** Figma "BgBlur" 効果の BACKGROUND_BLUR radius 80 → CSS blur(40px)。
     *  GlassScrollLayout の「画面に固定した背景画像」をぼかす。 */
    backdrop: 40,
};
